import ResourceLoaderProto from '../../core/core3-depricated/app/resource-loader-proto';

const appLoaderFunction = () => import(/* webpackChunkName: "report-view" */ './app');

export default class AppLoader_Report extends ResourceLoaderProto {

    resources() {
        return [
            this._loadCSS('dashboard'),
            this._loadCSS('item-view'),
            this._loadCSS('reports-and-analytics', 'reports-and-analytics'),
            this._loadAPP(appLoaderFunction)
        ];
    }
}
